export const dateMaskPlaceholder = 'YYYY-MM-DD';

export const dateIsEmpty = (value: string) =>
  value === undefined ||
  value === '' ||
  value === null ||
  value === dateMaskPlaceholder;
